export const SHOW_MODAL = 'SHOW_CUSTOM_MODAL';
export const HIDE_MODAL = 'HIDE_CUSTOM_MODAL';
